/* global window */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import imgixSource from 'lib/utils/imgix-source'

export default class Imgix extends Component {
  static propTypes = {
    src: PropTypes.string,
    width: PropTypes.number.isRequired,
    height: PropTypes.number,
    alt: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    itemProp: PropTypes.string,
    passThrough: PropTypes.bool,
    dpr: PropTypes.number,
    className: PropTypes.string,
    dataAttr: PropTypes.string,
    lazyLoad: PropTypes.bool
  }

  shouldComponentUpdate (nextProps) {
    return (
      this.props.src !== nextProps.src ||
      this.props.width !== nextProps.width ||
      this.props.height !== nextProps.height ||
      this.props.alt !== nextProps.alt ||
      this.props.dpr !== nextProps.dpr ||
      this.props.passThrough !== nextProps.passThrough ||
      this.props.itemProp !== nextProps.itemProp
    )
  }

  source (width = this.props.width, height = this.props.height || this.props.width) {
    const { src, dpr, passThrough } = this.props
    if (passThrough) {
      return src
    }
    return imgixSource(src, width, height, 'crop', dpr)
  }

  handleClick = e => {
    if (this.props.onClick) {
      this.props.onClick(e)
    }
  }

  render () {
    const {
      width,
      height,
      alt,
      radius,
      itemProp,
      passThrough,
      className,
      onMouseLeave,
      onMouseEnter,
      dataAttr,
      lazyLoad
    } = this.props

    const style = {
      width: width,
      height: height || width,
      backgroundImage: `url(${this.source()})`,
      backgroundSize: passThrough ? 'cover' : `${width}px ${height || width}px`,
      backgroundPosition: 'center center',
      display: 'inline-block',
      borderRadius: radius
    }

    return lazyLoad ? (
      <LazyLoadComponent>
        <div
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          className={`div-img ${className}`}
          style={style}
          data-alt={alt}
          onClick={this.handleClick}
          data-attr={dataAttr}
        >
          {itemProp ? <meta itemProp={itemProp} content={this.source(300, 300)} /> : null}
        </div>
      </LazyLoadComponent>
    ) : (
      <div
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        className={`div-img ${className}`}
        style={style}
        data-alt={alt}
        onClick={this.handleClick}
        data-attr={dataAttr}
      >
        {itemProp ? <meta itemProp={itemProp} content={this.source(300, 300)} /> : null}
      </div>
    )
  }
}
